import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../../base/outline-element/outline-element';

type TokenData = { token: string | undefined; error: boolean };

/**
 * The TrustCommerce component.
 * @element ghs-trustcommerce
 */
@customElement('ghs-trustcommerce')
export class GhsTrustcommerce extends OutlineElement {
  @property()
  friendlyError: string;
  @property()
  text: string;
  @property()
  token: string;

  @property()
  data: TokenData;

  connectedCallback() {
    super.connectedCallback();
    this.fetchToken()
      .then(data => (this.data = data))
      .catch(() => (this.data = { error: true, token: undefined }));
  }

  async fetchToken(): Promise<TokenData> {
    const response = await fetch(this.token);
    if (!response.ok) {
      throw new Error(`Failed to fetch token: ${response.status}`);
    }
    return response.json();
  }

  render(): TemplateResult {
    if (!this.data) {
      return html` <p>Loading...</p> `;
    } else if (this.data !== undefined && this.data.error) {
      return html`<p>${this.friendlyError}</p>`;
    }

    return html`
      <ghs-button
        url="https://vault.trustcommerce.com/trustee/payment.php?token=${this
          .data.token}"
        button-target="_blank"
        >${this.text}</ghs-button
      >
    `;
  }
}
